module.exports = __webpack_public_path__ + "img/Img4b_204176_BiEq-6-2.863b77b2.jpg";